module.exports = "pegasus/assets/blocks/social-1-theme3.png";